import { gql } from "graphql-tag";
import {
  ApolloClient,
  ApolloQueryResult,
  InMemoryCache,
} from "@apollo/client/core";
import type { Corollary } from "@/models/common";
import type { GotMyAppGroups } from "@/models/manager";

const query = gql`
  query getMyAppGroups {
    getMyAppGroups {
      __typename
      ... on GotMyAppGroups {
        appGroups {
          appGroup {
            appgroupId
            accountId
            name
          }
        }
      }
      ... on Corollary {
        code
        message
      }
    }
  }
`;

export type getMyAppGroupsResponse = ApolloQueryResult<{
  getMyAppGroups: GotMyAppGroups | Corollary;
}>;

export interface MyAppGroupsResponse {
  __typename?: string;
  appGroups?: GotMyAppGroups;
  failure?: { message: string; code: string };
}

/**
 * Retrieve appGroups that the signed-in user has permission to access"
 *
 * Commits the received value to the store.
 * @param client - Apollo client used for query execution.
 * @returns Object containing the GraphQL result and list of appGroups if
 *   successful
 */
export async function getMyServiceGroups(
  client: ApolloClient<InMemoryCache>
): Promise<MyAppGroupsResponse> {
  const response: getMyAppGroupsResponse = await client.query({
    query,
    fetchPolicy: "no-cache",
  });
  const typeName = response.data.getMyAppGroups.__typename;
  return typeName === "GotMyAppGroups"
    ? {
        appGroups: response.data.getMyAppGroups as GotMyAppGroups,
      }
    : {
        failure: response.data.getMyAppGroups as Corollary,
      };
}
